// The two service pathways. No published prices — pricing is by written quote after an enquiry.

export const PATHWAYS = [
  {
    slug: "career-strategy",
    interest: "Career Strategy, CV and LinkedIn",
    title: "Career Strategy, CV and LinkedIn",
    eyebrow: "Core service",
    summary:
      "One combined service for people who want a clear plan and the documents to match. We help you build your professional pitch, then shape your CV and LinkedIn profile around it.",
    included: [
      "A discussion about your career goals and suitable opportunities.",
      "Identification of your relevant skills, experience and achievements.",
      "A new or revised CV that clearly explains the value you can bring.",
      "LinkedIn optimisation aligned with your CV.",
      "Practical guidance on the next steps in your job search.",
    ],
    note:
      "Your CV is written as a clear employment pitch supported by evidence. Its structure stays familiar and easy for recruiters and recruitment software to read. Help with individual applications and interview preparation is also available. Ask about this in your enquiry.",
    pricing:
      "This service is priced by quote. Request a quote and we will confirm the scope, then email you a written quote you can accept and pay securely online. Requesting a quote does not charge or commit you.",
    cta: "Request a quote",
    ctaTestId: "enquire-career-btn",
  },
  {
    slug: "small-business",
    interest: "Small Business and Self Employment",
    title: "Small Business and Self Employment",
    eyebrow: "Tailored programmes",
    summary:
      "Tailored programmes delivered online for people exploring how their skills and experience could become a small business or an independent service.",
    included: [
      "Exploring a business idea.",
      "Identifying potential customers and their needs.",
      "Developing a clear service offering and business pitch.",
      "Planning practical first steps.",
      "Exploring useful digital and AI tools.",
    ],
    note:
      "Every programme is shaped around you. The scope is agreed individually before any work begins.",
    pricing:
      "Programmes are priced by quote. Request a quote and we will discuss your idea, then email you a written quote you can accept and pay securely online. Requesting a quote does not charge or commit you.",
    cta: "Request a quote",
    ctaTestId: "enquire-business-btn",
  },
];

// Legacy detail-page slugs kept so old URLs can redirect cleanly.
export const LEGACY_SLUGS = ["cv-review", "cv-writing", "linkedin-optimisation", "power-pair"];
